import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const FAQS = [
  {
    question: 'What areas do you cover?',
    answer:
      "We're based in Sidcup and cover all of South East London, including Lewisham, Bromley, Bexley, Greenwich and Orpington.",
  },
  {
    question: 'Do you offer free quotes?',
    answer:
      "Yes. We'll visit your property, discuss your project, and provide a free, no-obligation quote.",
  },
  {
    question: 'How long does a typical driveway or patio installation take?',
    answer:
      "Timescales vary depending on size, ground conditions, and the materials chosen. We'll give you a clear timeframe as part of your quote.",
  },
  {
    question: 'What materials do you work with?',
    answer:
      'We install block paving, natural stone patios, resin driveways, composite and timber decking, and fencing. We can advise on the best option for your budget and property.',
  },
  {
    question: 'Do you provide a guarantee on your work?',
    answer:
      'Yes, all of our installations come with a 3-year workmanship guarantee. Materials are covered separately by the relevant manufacturer warranty.',
  },
  {
    question: 'Do I need planning permission for a new driveway?',
    answer:
      "It depends on the materials and drainage used. Permeable surfaces (such as resin or permeable block paving) typically don't require planning permission. We can advise on this during your quote visit.",
  },
  {
    question: 'How do I get started?',
    answer: (
      <>
        Get in touch via our <a href="/booking">contact form</a>, by emailing{' '}
        <a href="mailto:hello@pavemend.co.uk">hello@pavemend.co.uk</a>, or by
        calling <a href="tel:+447462911383">07462 911 383</a>. We'll arrange a
        free site visit and quote.
      </>
    ),
    plainAnswer:
      "Get in touch via our contact form, by emailing hello@pavemend.co.uk, or by calling 07462 911 383. We'll arrange a free site visit and quote.",
  },
];

const FAQPage = () => {
  useEffect(() => {
    document.title = 'FAQs – PaveMend';
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.href = 'https://pavemend.co.uk/faq';

    let metaDesc = document.querySelector('meta[name="description"]');
    const created = !metaDesc;
    if (created) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content =
      'Answers to common questions about PaveMend driveways, patios, decking and fencing installations across South East London.';

    const schema = document.createElement('script');
    schema.type = 'application/ld+json';
    schema.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: FAQS.map(({ question, answer, plainAnswer }) => ({
        '@type': 'Question',
        name: question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: plainAnswer ?? answer,
        },
      })),
    });
    document.head.appendChild(schema);

    return () => {
      document.title =
        'PaveMend – Driveways, Patios & Paving in South East London';
      if (canonical) canonical.href = 'https://pavemend.co.uk/';
      if (created && metaDesc.parentNode) {
        document.head.removeChild(metaDesc);
      } else if (metaDesc) {
        metaDesc.content =
          "PaveMend is South East London's trusted hardscaping contractor. Expert driveway, patio, and paving installations with a free quote.";
      }
      document.head.removeChild(schema);
    };
  }, []);

  return (
    <div className="legal-page faq-page">
      <div className="legal-page__hero">
        <div className="container">
          <p className="section-eyebrow">FAQs</p>
          <h1 className="legal-page__title">Frequently Asked Questions</h1>
          <p className="legal-page__meta">
            Everything you need to know before getting started
          </p>
        </div>
      </div>

      <div className="legal-page__body">
        <div className="container">
          <div className="legal-page__content">
            <div className="faq-list">
              {FAQS.map(({ question, answer }) => (
                <details className="faq-item" key={question}>
                  <summary className="faq-item__question">{question}</summary>
                  <p className="faq-item__answer">{answer}</p>
                </details>
              ))}
            </div>

            <div className="legal-page__back">
              <Link to="/">Back to Home</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
